import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { handlePostApis } from "../../service/Api";

// IST date as YYYY-MM-DD, `days` from today (Delhivery schedules by local date).
const istDate = (days) => new Date(Date.now() + (5.5 + 24 * days) * 3600 * 1000).toISOString().slice(0, 10);

/** Asks Delhivery to collect the packed parcels from the warehouse. */
const PickupModal = ({ isOpen, toggle, config }) => {
  const [form, setForm] = useState({ date: istDate(1), time: "11:00", count: "" });
  const [saving, setSaving] = useState(false);
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await handlePostApis("admin/shipping/pickup", {
        date: form.date,
        time: form.time,
        count: Number(form.count) || undefined,
      });
      if (res?.data?.success) {
        toast.success(res.data.message);
        toggle();
      } else {
        toast.error(res?.data?.message || "Pickup request failed");
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered" size="sm">
      <form onSubmit={submit}>
        <ModalHeader toggle={toggle}>Schedule Delhivery Pickup</ModalHeader>
        <ModalBody>
          <p className="text-soft fs-13px">
            From <strong>{config?.pickup_location}</strong>. {config?.pending_pickup || 0} parcel(s) are waiting for pickup.
          </p>
          <div className="form-group">
            <label className="form-label">Date</label>
            <input type="date" className="form-control" value={form.date} min={istDate(0)} onChange={set("date")} required />
          </div>
          <div className="form-group">
            <label className="form-label">Time</label>
            <input type="time" className="form-control" value={form.time} onChange={set("time")} required />
          </div>
          <div className="form-group mb-0">
            <label className="form-label">Parcels</label>
            <input
              type="number" min="1" max="500" className="form-control"
              placeholder={String(config?.pending_pickup || 1)}
              value={form.count} onChange={set("count")}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="light" type="button" onClick={toggle} disabled={saving}>Cancel</Button>
          <Button color="primary" type="submit" disabled={saving}>
            {saving ? <><Spinner size="sm" className="me-1" /> Scheduling...</> : "Schedule Pickup"}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default PickupModal;
